import { FC, useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { REDESIGN_NS } from "../i18n";
import { ThemeMode } from "../lib/theme";
import { useTheme } from "../lib/useTheme";
import { IconDisplay, IconMoon, IconSun } from "../ui/icons";
import { useDismissable } from "../ui/useDismissable";

const OPTIONS: { mode: ThemeMode; labelKey: string; Icon: typeof IconSun }[] = [
  { mode: "light", labelKey: "Light", Icon: IconSun },
  { mode: "dark", labelKey: "Dark", Icon: IconMoon },
  { mode: "system", labelKey: "System", Icon: IconDisplay },
];

const ThemeMenu: FC = () => {
  const { t } = useTranslation(REDESIGN_NS);
  const { mode, resolved, setMode } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const close = useCallback(() => setIsOpen(false), []);
  useDismissable(anchorRef, isOpen, close);

  /*
   * Tetikleyicideki ikon seçilen kipi değil yürürlükteki temayı gösterir; hangi kipin
   * seçili olduğu menüde zaten işaretli.
   */
  const CurrentIcon = resolved === "dark" ? IconMoon : IconSun;

  const select = (next: ThemeMode) => {
    setMode(next);
    close();
  };

  return (
    <div className="sso-rd__menu-anchor" ref={anchorRef}>
      <button
        type="button"
        className="sso-rd__theme-btn"
        onClick={() => setIsOpen((open) => !open)}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-label={t("Theme")}
        title={t("Theme")}
      >
        <CurrentIcon size={17} />
      </button>

      <div
        className={"sso-rd__theme-menu" + (isOpen ? " is-open" : "")}
        role="menu"
      >
        {OPTIONS.map((option) => (
          <button
            key={option.mode}
            type="button"
            role="menuitemradio"
            aria-checked={option.mode === mode}
            className={
              "sso-rd__theme-option" + (option.mode === mode ? " is-active" : "")
            }
            onClick={() => select(option.mode)}
          >
            <option.Icon size={16} />
            {t(option.labelKey)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ThemeMenu;
